import { default as access_45controlItCeGGTVo9Meta } from "/app/pages/access-control.vue?macro=true";
import { default as article_45queuefYyTBpZKN3Meta } from "/app/pages/agents/article-queue.vue?macro=true";
import { default as article_45reviewBOa4upOzciMeta } from "/app/pages/agents/article-review.vue?macro=true";
import { default as lead_45scoutTXvMDXr2xDMeta } from "/app/pages/agents/lead-scout.vue?macro=true";
import { default as lead_45viewpzChSHP90fMeta } from "/app/pages/agents/lead-view.vue?macro=true";
import { default as testRr5APldHypMeta } from "/app/pages/agents/test.vue?macro=true";
import { default as virtual_45assistanturTa9MdSqXMeta } from "/app/pages/agents/virtual-assistant.vue?macro=true";
import { default as _91id_93GfbQespuG8Meta } from "/app/pages/articles/[id].vue?macro=true";
import { default as indexnFjuerN8cOMeta } from "/app/pages/articles/index.vue?macro=true";
import { default as _91id_93nFE2lphWPLMeta } from "/app/pages/articles/settings/[id].vue?macro=true";
import { default as indexFbLwU4WD8YMeta } from "/app/pages/articles/settings/index.vue?macro=true";
import { default as _91id_93wl3GyypIRBMeta } from "/app/pages/articles/topics/[id].vue?macro=true";
import { default as indexUtpAasxfATMeta } from "/app/pages/articles/topics/index.vue?macro=true";
import { default as _91id_93epN4yBoWyFMeta } from "/app/pages/chatbots/[id].vue?macro=true";
import { default as indexE56etB00PYMeta } from "/app/pages/chatbots/index.vue?macro=true";
import { default as defaultet58XCtOhQMeta } from "/app/pages/dashboards/default.vue?macro=true";
import { default as forgot_45password1UbT4qDpFeMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as indexNjCnEt0EoCMeta } from "/app/pages/images/image-to-image/index.vue?macro=true";
import { default as indexCMGsx0qxUaMeta } from "/app/pages/images/text-to-image/index.vue?macro=true";
import { default as _91id_93unUc0kZ0v9Meta } from "/app/pages/knowledgebase/[id].vue?macro=true";
import { default as index9D9g4gOLQFMeta } from "/app/pages/knowledgebase/index.vue?macro=true";
import { default as _91id_93lKRDgcolrjMeta } from "/app/pages/leads/[id].vue?macro=true";
import { default as indexmGgaaN8WnPMeta } from "/app/pages/leads/index.vue?macro=true";
import { default as _91id_93wpO4TqVjHjMeta } from "/app/pages/leads/qualifiers/[id].vue?macro=true";
import { default as indexKW5cP4UNnYMeta } from "/app/pages/leads/qualifiers/index.vue?macro=true";
import { default as _91id_93mH8AzfmQnlMeta } from "/app/pages/leads/settings/[id].vue?macro=true";
import { default as indexV1mqr395BEMeta } from "/app/pages/leads/settings/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as not_45authorizedc3RyReHyWQMeta } from "/app/pages/not-authorized.vue?macro=true";
import { default as registermu8R7rSP5uMeta } from "/app/pages/register.vue?macro=true";
import { default as accountFbmhd9M064Meta } from "/app/pages/settings/account.vue?macro=true";
import { default as _91id_93nDQ2NKWll2Meta } from "/app/pages/users/[id].vue?macro=true";
import { default as indexnq54o81oozMeta } from "/app/pages/users/index.vue?macro=true";
export default [
  {
    name: "access-control",
    path: "/access-control",
    meta: access_45controlItCeGGTVo9Meta || {},
    component: () => import("/app/pages/access-control.vue")
  },
  {
    name: "agents-article-queue",
    path: "/agents/article-queue",
    meta: article_45queuefYyTBpZKN3Meta || {},
    component: () => import("/app/pages/agents/article-queue.vue")
  },
  {
    name: "agents-article-review",
    path: "/agents/article-review",
    meta: article_45reviewBOa4upOzciMeta || {},
    component: () => import("/app/pages/agents/article-review.vue")
  },
  {
    name: "agents-lead-scout",
    path: "/agents/lead-scout",
    component: () => import("/app/pages/agents/lead-scout.vue")
  },
  {
    name: "agents-lead-view",
    path: "/agents/lead-view",
    meta: lead_45viewpzChSHP90fMeta || {},
    component: () => import("/app/pages/agents/lead-view.vue")
  },
  {
    name: "agents-test",
    path: "/agents/test",
    component: () => import("/app/pages/agents/test.vue")
  },
  {
    name: "agents-virtual-assistant",
    path: "/agents/virtual-assistant",
    meta: virtual_45assistanturTa9MdSqXMeta || {},
    component: () => import("/app/pages/agents/virtual-assistant.vue")
  },
  {
    name: "articles-id",
    path: "/articles/:id()",
    meta: _91id_93GfbQespuG8Meta || {},
    component: () => import("/app/pages/articles/[id].vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: indexnFjuerN8cOMeta || {},
    component: () => import("/app/pages/articles/index.vue")
  },
  {
    name: "articles-settings-id",
    path: "/articles/settings/:id()",
    meta: _91id_93nFE2lphWPLMeta || {},
    component: () => import("/app/pages/articles/settings/[id].vue")
  },
  {
    name: "articles-settings",
    path: "/articles/settings",
    meta: indexFbLwU4WD8YMeta || {},
    component: () => import("/app/pages/articles/settings/index.vue")
  },
  {
    name: "articles-topics-id",
    path: "/articles/topics/:id()",
    meta: _91id_93wl3GyypIRBMeta || {},
    component: () => import("/app/pages/articles/topics/[id].vue")
  },
  {
    name: "articles-topics",
    path: "/articles/topics",
    meta: indexUtpAasxfATMeta || {},
    component: () => import("/app/pages/articles/topics/index.vue")
  },
  {
    name: "chatbots-id",
    path: "/chatbots/:id()",
    meta: _91id_93epN4yBoWyFMeta || {},
    component: () => import("/app/pages/chatbots/[id].vue")
  },
  {
    name: "chatbots",
    path: "/chatbots",
    meta: indexE56etB00PYMeta || {},
    component: () => import("/app/pages/chatbots/index.vue")
  },
  {
    name: "dashboards-default",
    path: "/dashboards/default",
    component: () => import("/app/pages/dashboards/default.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password1UbT4qDpFeMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "images-image-to-image",
    path: "/images/image-to-image",
    meta: indexNjCnEt0EoCMeta || {},
    component: () => import("/app/pages/images/image-to-image/index.vue")
  },
  {
    name: "images-text-to-image",
    path: "/images/text-to-image",
    meta: indexCMGsx0qxUaMeta || {},
    component: () => import("/app/pages/images/text-to-image/index.vue")
  },
  {
    name: "knowledgebase-id",
    path: "/knowledgebase/:id()",
    meta: _91id_93unUc0kZ0v9Meta || {},
    component: () => import("/app/pages/knowledgebase/[id].vue")
  },
  {
    name: "knowledgebase",
    path: "/knowledgebase",
    meta: index9D9g4gOLQFMeta || {},
    component: () => import("/app/pages/knowledgebase/index.vue")
  },
  {
    name: "leads-id",
    path: "/leads/:id()",
    meta: _91id_93lKRDgcolrjMeta || {},
    component: () => import("/app/pages/leads/[id].vue")
  },
  {
    name: "leads",
    path: "/leads",
    meta: indexmGgaaN8WnPMeta || {},
    component: () => import("/app/pages/leads/index.vue")
  },
  {
    name: "leads-qualifiers-id",
    path: "/leads/qualifiers/:id()",
    meta: _91id_93wpO4TqVjHjMeta || {},
    component: () => import("/app/pages/leads/qualifiers/[id].vue")
  },
  {
    name: "leads-qualifiers",
    path: "/leads/qualifiers",
    meta: indexKW5cP4UNnYMeta || {},
    component: () => import("/app/pages/leads/qualifiers/index.vue")
  },
  {
    name: "leads-settings-id",
    path: "/leads/settings/:id()",
    meta: _91id_93mH8AzfmQnlMeta || {},
    component: () => import("/app/pages/leads/settings/[id].vue")
  },
  {
    name: "leads-settings",
    path: "/leads/settings",
    meta: indexV1mqr395BEMeta || {},
    component: () => import("/app/pages/leads/settings/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "not-authorized",
    path: "/not-authorized",
    meta: not_45authorizedc3RyReHyWQMeta || {},
    alias: ["/pages/misc/not-authorized"],
    component: () => import("/app/pages/not-authorized.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registermu8R7rSP5uMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "settings-account",
    path: "/settings/account",
    meta: accountFbmhd9M064Meta || {},
    component: () => import("/app/pages/settings/account.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    meta: _91id_93nDQ2NKWll2Meta || {},
    component: () => import("/app/pages/users/[id].vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexnq54o81oozMeta || {},
    component: () => import("/app/pages/users/index.vue")
  }
]